import * as sdk from '@cirqll/sdk';
import type { FieldCategory } from '@cirqll/sdk/enum';
import { useQuery } from '@tanstack/vue-query';

export function useFields(category?: MaybeRefOrGetter<FieldCategory>) {
    return useQuery({
        ...sdk.field.index({ limit: 1000 }),
        select: (data) => {
            const cat = toValue(category);
            return cat ? data.data.filter((f) => f.category === cat) : data.data;
        },
    });
}
